export var CustomAttributeDataKeys;
(function (CustomAttributeDataKeys) {
    CustomAttributeDataKeys["PreferredLanguage"] = "preferredLanguage";
    CustomAttributeDataKeys["NewsletterPreferences"] = "newsletterPreferences";
    CustomAttributeDataKeys["TextMessagePreferences"] = "textMessagePreferences";
    CustomAttributeDataKeys["PostMailPreferences"] = "postMailPreferences";
})(CustomAttributeDataKeys || (CustomAttributeDataKeys = {}));
/**
 * @deprecated Use CustomAttributeDataKeys instead
 */
export var DataKeys;
(function (DataKeys) {
    DataKeys["PreferredLanguage"] = "preferredLanguage";
    DataKeys["NewsletterPreferences"] = "newsletterPreferences";
    DataKeys["TextMessagePreferences"] = "textMessagePreferences";
    DataKeys["PostMailPreferences"] = "postMailPreferences";
})(DataKeys || (DataKeys = {}));
//# sourceMappingURL=CustomAttribute.js.map